// removed by extract-text-webpack-plugin
module.exports = {"checkLimitText":"checkLimitText__1HfpR","successLogoContainer":"successLogoContainer__O6BHJ","successLogoInnerContainer":"successLogoInnerContainer__2oQPs","successLogo":"successLogo__1X62V","checkLimitHeading":"checkLimitHeading__3RF96","closeIconContainer":"closeIconContainer__2OQn1","closeIcon":"closeIcon__zianN","lenderLogoContainer":"lenderLogoContainer__1l3M9","checkLimitPromptText":"checkLimitPromptText__1RfXX","innerText":"innerText__1jQX_"};


//////////////////
// WEBPACK FOOTER
// ./components/partial/layers/modals/onLimitCheckModal/style.css
// module id = U1xn
// module chunks = 308 314 317 321 336 337 347